import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SlowImage = ({ src, alt, className = "", imgClassName = "" }) => (
  <motion.div
    className={`overflow-hidden ${className}`}
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 1.2, ease: EASE }}
  >
    <motion.img
      src={src}
      alt={alt}
      loading="lazy"
      className={`h-full w-full object-cover ${imgClassName}`}
      initial={{ scale: 1.12 }}
      whileInView={{ scale: 1 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 1.6, ease: EASE }}
    />
  </motion.div>
);

export const SectionLabel = ({ index, text, light = false }) => (
  <FadeUp className="flex items-center gap-4">
    <span className="hv-nums font-serif italic text-lg text-gold">{index}</span>
    <span className={`h-px w-10 ${light ? "bg-gold/60" : "bg-gold/50"}`} />
    <span
      className={`font-sans text-[11px] tracking-[0.35em] ${
        light ? "text-[#8a6f45]" : "text-gold"
      }`}
    >
      {text}
    </span>
  </FadeUp>
);
